<template>
  <el-dialog width="750px" title="问卷预览" :visible.sync="visible" @close="dialogClose">
    <div class="temp-preview-box">
      <iframe :src="previewUrl" class="previewPcIframe" frameborder="" name="preview_frame"></iframe>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="confirm-btn" type="primary" @click="handleConfirm">使用该模板</el-button>
    </span>
  </el-dialog>
</template>
<script>
import http from "../utils/http";

export default {
  name: "templatePreivew",
  data() {
    return {
      interface: {
        createWithTemplate: `/template/createWithTemplate`
      },
      visible: false
    };
  },
  props: ["previewUrl", "dialogShow"],
  watch: {
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    }
  },
  methods: {
    getParams(key) {
      const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
      const result = this.previewUrl.split("?")[1].match(reg);
      if (result != null) {
        return decodeURIComponent(result[2]);
      }
      return null;
    },
    handleConfirm() {
      http
        .get(this.interface.createWithTemplate, {
          templateId: this.getParams("id")
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.$router.push({
              path: "/home/edit",
              query: {
                id: data.id
              }
            });
          }
        })
        .catch(error => {
          // MSG.error(error);
        });
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    }
  }
};
</script>


<style lang="scss" scoped>
.temp-preview-box {
  .previewPcIframe {
    margin: 0 auto;
    width: 710px;
    height: 400px;
    border: 1px solid #eee;
  }
}
.confirm-btn {
  background-image: linear-gradient(270deg, #ff9000 0%, #ff552e 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/templatePreviewDialog.vue